import { FilterBar, SelectV2, SortDropdownValue } from "@/modules/common/components";
import { EntityFilterBar, UseFiltersResult } from "@/modules/common/filters";
import {
  AdminManagementCompanySortField,
  MANAGEMENT_COMPANY_STATUS_OPTIONS,
  MANAGEMENT_MODEL_OPTIONS,
  MANAGEMENT_USAGE_TYPE_OPTIONS,
  ManagementCompanyStatus,
  ManagementCompanyUsageType,
  ManagementModel,
} from "@/modules/common/types/ManagementCompanies.enum";

import { MANAGEMENT_COMPANY_FILTER_FIELDS } from "../../constants/ManagementCompanyFilterFields";
import { ListAdminManagementCompaniesDto } from "@/service/dto/admin-management-companies";
import useManagementCompanyOwners from "@/modules/common/hooks/lists/useManagementCompanyOwners";

const MANAGEMENT_COMPANY_SORT_OPTIONS = [
  { field: AdminManagementCompanySortField.NAME, label: "Nome" },
  { field: AdminManagementCompanySortField.CREATED_AT, label: "Data de criação" },
  { field: AdminManagementCompanySortField.STATUS, label: "Status" },
];

interface ManagerFilterBarProps {
  filters: UseFiltersResult<ListAdminManagementCompaniesDto>;
  sort: SortDropdownValue<AdminManagementCompanySortField> | null;
  onSortChange: (sort: SortDropdownValue<AdminManagementCompanySortField> | null) => void;
}

const ManagerFilterBar = ({ filters, sort, onSortChange }: ManagerFilterBarProps) => {
  const {
    options: ownerOptions,
    isLoading: isLoadingOwnerOptions,
    hasMore: hasMoreOwnerOptions,
    onLoadMore: fetchMoreOwnerOptions,
  } = useManagementCompanyOwners();

  return (
    <EntityFilterBar
      filters={filters}
      sort={sort}
      onSortChange={onSortChange}
      sortOptions={MANAGEMENT_COMPANY_SORT_OPTIONS}
      filterFields={MANAGEMENT_COMPANY_FILTER_FIELDS}
      modalTitle="Filtrar Gestoras"
    >
      <FilterBar.Item>
        <SelectV2
          mode="single"
          placeholder="Modelo de gestão"
          options={MANAGEMENT_MODEL_OPTIONS}
          value={filters.values.managementModel !== undefined ? String(filters.values.managementModel) : undefined}
          onChange={(next) => filters.setValue("managementModel", next !== undefined ? (Number(next) as ManagementModel) : undefined)}
        />
      </FilterBar.Item>

      <FilterBar.Item>
        <SelectV2
          mode="multiple"
          placeholder="Status"
          options={MANAGEMENT_COMPANY_STATUS_OPTIONS}
          value={filters.values.status?.map(String) ?? []}
          onChange={(next) => filters.setValue("status", next.length ? (next.map(Number) as ManagementCompanyStatus[]) : undefined)}
        />
      </FilterBar.Item>

      <FilterBar.Item>
        <SelectV2
          mode="single"
          placeholder="Tipo da Gestora"
          options={MANAGEMENT_USAGE_TYPE_OPTIONS}
          value={filters.values.usageType !== undefined ? String(filters.values.usageType) : undefined}
          onChange={(next) => filters.setValue("usageType", next !== undefined ? (Number(next) as ManagementCompanyUsageType) : undefined)}
        />
      </FilterBar.Item>

      <FilterBar.Item>
        <SelectV2
          mode="single"
          placeholder="Representante"
          options={ownerOptions}
          isLoading={isLoadingOwnerOptions}
          hasMore={hasMoreOwnerOptions}
          onLoadMore={fetchMoreOwnerOptions}
          value={filters.values.ownerId}
          onChange={(next) => filters.setValue("ownerId", next)}
        />
      </FilterBar.Item>
    </EntityFilterBar>
  );
};

export default ManagerFilterBar;
